import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SupervisorReportService } from '../../services/supervisor-report.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { ShipService } from '../../services/ship.service';
import { ActivityService } from '../../services/activity.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { WorkShiftService } from '../../services/work-shift.service';

import { Utils } from '../../util';

@Component({
	selector: 'app-update-supervisor-report',
	templateUrl: './update-supervisor-report.component.html',
	styleUrls: ['./update-supervisor-report.component.css', '../../app.component.css']
})

export class UpdateSupervisorReportComponent implements OnInit, OnDestroy {

	reportForm: FormGroup;
	report: any = [];

	supervisors = {};
	supervisorInit: any;
	supervisorText = '';

	projects = {};
	projectInit: any;
	projectText = '';

	ships = {};
	shipInit: any;
	shipText = '';

	pickadateParams = Utils.pickadateParams();

	id: string;
	reportDate: any;

	employees = {};
	employeeInit: any;
	employeeText = '';

	activities = {};
	activityInit: any;
	activityText = '';

	employeeForm: FormGroup;
	employee: any = [];

	activitiesCapture: number;

	pickatimeParams = Utils.pickatimeParams();

	workShifts: any = [];

	startTime = '01:00';
	endTime = '23:00';
	workShiftVal: string;

	startTimeInit: any;
	endTimeInit: any;

	advanceValue = '';

	employeesReport: any[] = [];

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
		{ title: 'Empleado', name: 'employeeName' },
		{ title: 'Actividad realizada', name: 'activityName' },
		{ title: 'Avance', name: 'advanceValue', className: 'center' },
		{ title: 'Turno', name: 'workShiftName', className: 'center' },
		{ title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
			  styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
	];

	page = 1;
	itemsPerPage = 20;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		className: ['striped'],
		api: {
			onDelete: this.onDelete.bind(this)
		}
	};

	registeredEmployeesNumber = 0;

	gsrSubs: any;
	gpsSubs: any;
	gwsSubs: any;
	geSubs: any;
	gpoSubs: any;
	gsSubs: any;
	gaSubs: any;
	gerSubs: any;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private supervisorReportService: SupervisorReportService,
		private employeeService: EmployeeService,
		private productionOrderService: ProductionOrderService,
		private shipService: ShipService,
		private activityService: ActivityService,
		private catalogsSettingsService: CatalogsSettingsService,
		private workShiftService: WorkShiftService
	) {
		this.supervisors = {};
		this.projects = {};
		this.ships = {};
		this.employees = {};
		this.activities = {};
		this.loadSupervisorsAndProjectsAndActivities();

		this.activatedRoute.params.subscribe(parameters => {
			this.id = parameters['id'];

			this.gsrSubs = this.supervisorReportService.getSupervisorReport(this.id).subscribe(reportObj => {
				this.gsrSubs.unsubscribe();

				this.report = reportObj[0];

				this.supervisorText = this.report.employeeObj.employeeName;
				this.projectText = this.report.productionOrderObj.productionOrderName;
				this.reportDate = Utils.convertDatefromStringtoISOString(this.report.reportDate);
				this.startTimeInit = this.report.startTime;
				this.endTimeInit = this.report.endTime;
				this.startTime = this.startTimeInit;
				this.endTime = this.endTimeInit;
				this.shipText = this.report.shipObj.shipDescription;

				this.gpsSubs = this.catalogsSettingsService.getPayrollSettings('1').subscribe(payrollObj => {
					this.gpsSubs.unsubscribe();

					this.activitiesCapture = payrollObj.activitiesCapture;

					this.gwsSubs = workShiftService.getWorkShifts().subscribe(tempWorkShifts => {
						this.gwsSubs.unsubscribe();

						this.workShifts = tempWorkShifts;
						this.workShiftVal = this.workShifts[0].id$;
					});
				});
			});

			this.loadEmployeesReport();

			
		});
	}

	ngOnInit() {
		this.reportForm = this.formBuilder.group({
			supervisor: ['', Validators.required],
			project: ['', Validators.required],
			reportDate: ['', Validators.required],
			startTime: ['', Validators.required],
			endTime: ['', [Validators.required]],
			ship: ['', [Validators.required]]
		});

		this.employeeForm = this.formBuilder.group({
			employee: ['', Validators.required],
			activity: ['', Validators.required],
			startTime: ['', Validators.required],
			endTime: ['', Validators.required],
			workShift: ['', Validators.required],
			advanceValue: ''
		});
	}

	onSubmitReport() {
		this.report = this.saveReport();

		this.supervisorReportService.putSupervisorReport(this.report, this.id).then(res => {
			this.router.navigate(['/supervisor_reports']);
		});
	}

	saveReport() {
		const reportDate = Utils.convertDatefromISOStringtoObject(this.reportForm.get('reportDate').value);

		const reportJson = {
			employeeId: this.supervisors[this.reportForm.get('supervisor').value],
			endTime: this.reportForm.get('endTime').value,
			productionOrderId: this.projects[this.reportForm.get('project').value],
			reportDate:  reportDate,
			shipId: this.ships[this.reportForm.get('ship').value],
			startTime: this.reportForm.get('startTime').value,
			updatedAt: new Date()
		};

		return reportJson;
	}

	loadSupervisorsAndProjectsAndActivities() {
		this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
			const dataEmployee = {};

			for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
				dataEmployee[employeeDisplayValue] = null;
				this.supervisors[employeeDisplayValue] = tempEmployees[idx].id$;
				this.employees[employeeDisplayValue] = tempEmployees[idx].id$;
			}

			this.supervisorInit = {
				'data': dataEmployee,
				onAutocomplete: (val) => { // console.log(val); // console.log(this.supervisors[val]);
				}
			};

			this.employeeInit = {
				'data': dataEmployee,
				onAutocomplete: (val) => { // console.log(val); // console.log(this.employees[val]);
				}
			};
		});

		this.gpoSubs = this.productionOrderService.getProductionOrders().subscribe(tempProjects => {
			const dataProject = {};

			for (const idx in tempProjects) {
				dataProject[tempProjects[idx].name] = null;
				this.projects[tempProjects[idx].name] = tempProjects[idx].id$;
			}

			this.projectInit = {
				'data': dataProject,
				onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
				}
			};
		});

		this.gsSubs = this.shipService.getShips().subscribe(tempShips => {
			const dataShip = {};

			for (const idx in tempShips) {
				dataShip[tempShips[idx].description] = null;
				this.ships[tempShips[idx].description] = tempShips[idx].id;
			}

			this.shipInit = {
				'data': dataShip,
				onAutocomplete: (val) => { // console.log(val); // console.log(this.ships[val]);
				}
			};
		});

		this.gaSubs = this.activityService.getActivities().subscribe(tempActivities => {
			const dataActivity = {};

			for (const idx in tempActivities) {
				dataActivity[tempActivities[idx].name] = null;
				this.activities[tempActivities[idx].name] = tempActivities[idx].id;
			}

			this.activityInit = {
				'data': dataActivity,
				onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
				}
			};
		});
	}

	onBlurSupervisor() {
		if (this.supervisors[this.supervisorText] === undefined) {
			this.supervisorText = '';
		}
	}

	onBlurProject() {
		if (this.projects[this.projectText] === undefined) {
			this.projectText = '';
		}
	}

	onBlurShip() {
		if (this.ships[this.shipText] === undefined) {
			this.shipText = '';
		}
	}

	onBlurEmployee() {
		if (this.employees[this.employeeText] === undefined) {
			this.employeeText = '';
		}
	}

	onBlurActivity() {
		if (this.activities[this.activityText] === undefined) {
			this.activityText = '';
		}
	}

	onSubmitEmployee() {
		this.employee = this.saveEmployee();

		this.supervisorReportService.postEmployeeReport(this.employee, this.id).then(res => {
			this.employeeText = '';
			this.activityText = '';
			this.startTime = this.startTimeInit;
			this.endTime = this.endTimeInit;
			this.workShiftVal = this.workShifts[0].id$;
			this.advanceValue = '';

			this.loadEmployeesReport();
		});
	}

	saveEmployee() {
		const currentDate = new Date();

		const employeeJson = {
			activitiesCapture: this.activitiesCapture,
			activityId: this.activities[this.employeeForm.get('activity').value],
			activityName: this.employeeForm.get('activity').value,
			advanceValue: this.employeeForm.get('advanceValue').value,
			createdAt: currentDate,
			employeeId: this.employees[this.employeeForm.get('employee').value],
			endTime: this.employeeForm.get('endTime').value,
			employeeName: this.employeeForm.get('employee').value,
			startTime: this.employeeForm.get('startTime').value,
			updatedAt: currentDate,
			workShiftId: this.employeeForm.get('workShift').value,
			workShiftName: this.workShifts.filter(x => x.id$ === this.employeeForm.get('workShift').value)[0].name
		};

		return employeeJson;
	}

	onDelete(data: any) {
		this.deleteEmployeeReport(data.row.id$);
	}

	deleteEmployeeReport(id$) {
		this.supervisorReportService.delEmployeeReport(id$, this.id).then(res => {
			this.loadEmployeesReport();
		});
	}

	loadEmployeesReport() {
		this.gerSubs = this.supervisorReportService.getEmployeesReport(this.id).subscribe(tempEmployeesReport => {
			this.employeesReport = [];

			for (const idx in tempEmployeesReport) {
				tempEmployeesReport[idx].advanceValue = (tempEmployeesReport[idx].advanceValue !== undefined ?
														  tempEmployeesReport[idx].advanceValue : '');

				this.employeesReport.push(tempEmployeesReport[idx]);
			}

			this.data = this.employeesReport;
			this.length = this.data.length;
			this.onChangeTable(this.config);

			this.registeredEmployeesNumber = this.data.length;
		});
	}

	ngOnDestroy() {
		this.geSubs.unsubscribe();
		this.gpoSubs.unsubscribe();
		this.gsSubs.unsubscribe();
		this.gaSubs.unsubscribe();
		this.gerSubs.unsubscribe();
	}



	// *************** Table functionality *************** //
	 changePage(page: any, data: Array<any> = this.data): Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}
